import React from 'react';
import _ from 'lodash';
import ReactHighcharts from 'react-highcharts';

class ColumnChartWidgetGroup extends React.Component {

    render() {
        if (this.props.isThumbnail) {
            return (<div className="column_chart_widget"/>);
        }

        const data = _.clone(this.props.widgetData);
        const categories = _.find(data, o => o.name === 'xAxisCategories');

        if (categories) data.shift();

        const options = {
            chart: {
                type: 'column',
                marginTop: 108,
                spacingBottom: 20,
                spacingLeft: 40,
                marginRight: 60,
            },
            tooltip: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: categories ? categories.data : null,
            },
            yAxis: {
                allowDecimals: false,
                min: 0,
                title: {
                    text: null,
                },
            },
            series: data,
        };

        if (this.props.widget.displayConfig.stacking) {
            options['plotOptions'] = {
                column: {
                    stacking: 'normal',
                },
            };
        }

        return (
            <div className="column_chart_widget">
                <ReactHighcharts config={options} isPureConfig />
            </div>
        );
    }

}

ColumnChartWidgetGroup.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
};

export default ColumnChartWidgetGroup;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/ColumnChartWidgetGroup.jsx
 **/